export default "__VITE_ASSET__DvmSzQj8__"